class Last5min {
    airTemperature: number = 0;
    humidity: number = 0;
    windSpeed: number = 0;
    windDirection: number = 0;
    cardinalDirection: string = '';
}

class Last30min {
    rainfall: number = 0;
}

class Since9am {
    rainfall: number = 0;
}

class Meeting {
    goingStickLastUpdated: string = '';
    goingStick: number = 0;
    trackRating: number = 0;
    penotrometer: number = 0;
    railPosition: string = '―';
}

class GoingStick {
    thisMeeting: Meeting = new Meeting();
    lastMeeting: Meeting = new Meeting();
}

class Moisture {
    time: string = '';
    moisture: number = 0;
}

class Last7days {
    irrigation: number[] = new Array<number>(7).fill(0);
}

class Last30days {
    rainfall: number[] = new Array<number>(30).fill(0);
}

class Weather {
    last5min: Last5min = new Last5min();
    last30min: Last30min = new Last30min();
    since9am: Since9am = new Since9am();
    goingStick: GoingStick = new GoingStick();
    moisture: Moisture = new Moisture();
    last7days: Last7days = new Last7days();
    last30days: Last30days =  new Last30days();
    jurisdiction: string = '';
}

export default Weather;